import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as Ci from "react-icons/ci";
import React from "react";

const SaleInTransit = () => {
    return (
        <>
            <div className="col-12 pt-0 pb-3">

                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Sale In Transit</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">

                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">GRN Number <span className="mandatory">*</span></label>
                                    <InputText className='form-control' required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">GRN Date <span className="mandatory">*</span></label>
                                    <Calendar showIcon required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Warehouse <span className="mandatory">*</span></label>
                                    <Dropdown required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Supplier Name <span className="mandatory">*</span></label>
                                    <Dropdown required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Supplier Invoice Number <span className="mandatory">*</span></label>
                                    <InputText className='form-control' required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Supplier Invoice Date <span className="mandatory">*</span></label>
                                    <Calendar showIcon required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Mode of Payment <span className="mandatory">*</span></label>
                                    <Dropdown required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Payment Term <span className="mandatory">*</span></label>
                                    <Dropdown required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Distributor Discount <span className="mandatory">*</span></label>
                                    <InputText className='form-control' required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Supplier Invoice Amount <span className="mandatory">*</span></label>
                                    <InputText className='form-control' required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Total Amount <span className="mandatory">*</span></label>
                                    <InputText className='form-control' disabled required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Customer Name <span className="mandatory">*</span></label>
                                    <Dropdown required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Customer Order Number <span className="mandatory">*</span></label>
                                    <InputText className='form-control' required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Tax Form <span className="mandatory">*</span></label>
                                    <Dropdown required />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 col-sm-12">
                                <div className='text-end mt-4'>
                                    <button type="submit" className="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>

                <section className="mt-3">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3>All Records</h3>
                        <div className="DataTable pb-4 pt-1">
                            <DataTable
                                // value={productGRNData}
                                // dataKey="INVH_NO"
                                paginator
                                rows={10}
                                // filterDisplay="row"
                                // showGridlines
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                stripedRows
                                // globalFilterFields={["PROD_CODE", "DESCRIPTION"]}
                                emptyMessage="No customers found."
                                tableStyle={{ minWidth: "60rem" }}
                            >
                                <Column field="" header="Product Code" />
                                <Column field="" header="Product List Number" />
                                <Column header="Order Quantity" className="text-end Right_Column" />
                                <Column field="" header="Extended Price(₹)" className="text-end Right_Column" />
                                <Column header="Free Given" />
                            </DataTable>
                        </div>
                    </div>
                    <div className="row me-2 grn-summery mb-4">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="total-panel">
                                <div className="total-box">
                                    <Ci.CiBeaker1 className="icon-sz" /> Net Volume(EA/Ltrs/Kg):
                                </div>
                                <div className="total-box">
                                    <span>100</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="total-panel">
                                <div className="total-box">
                                    <Ci.CiBag1 className="icon-sz" /> GST:
                                </div>
                                <div className="total-box">
                                    <span>100</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="total-panel">
                                <div className="total-box">
                                    <Ci.CiCalculator1 className="icon-sz" /> Net Amount:
                                </div>
                                <div className="total-box">
                                    <span>100</span>
                                </div>
                            </div>
                            <p className="small-text">Note here</p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default SaleInTransit;